import React from 'react';
import WorkshopCard from './WorkshopCard';

const WorkshopsGrid = ({ workshops, onJoin, onRemind }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
      {workshops.map((workshop) => (
        <WorkshopCard 
          key={workshop.id} 
          workshop={workshop} 
          onJoin={onJoin} 
          onRemind={onRemind}
        />
      ))}
    </div>
  );
};

export default WorkshopsGrid;